import { Component } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private router: Router, private titleService: Title, private http: HttpClient, private metaService: Meta) {

  }
  ngOnInit() {
    this.router.events.subscribe((res) => {
      if (res instanceof NavigationEnd) {
        this.http.get(`https://fsetan.ru/api/fsetan_seo/?url=fsetan.ru${res.url}`).subscribe((metaResponse:any) => {
          console.log(metaResponse);
          if(!metaResponse.results[0] || metaResponse.results[0]?.title === 'test-index' || metaResponse.results[0]?.title === 'Услуги'){
            this.titleService.setTitle('Протос Экспертиза - проведем экспертизу промышленной безопасности, техническое диагностирование, оформим лицензию Ростехнадзора, проведём аудит ОПО');
          } else this.titleService.setTitle(metaResponse.results[0].title);
          this.metaService.updateTag({ name: 'description', content: metaResponse?.results[0]?.description ? metaResponse?.results[0]?.description: '' });
        }, err => {
          let headings = document.getElementsByTagName('h1');
          this.titleService.setTitle(headings[0].innerText);
          this.metaService.updateTag({ name: 'description', content: headings[0].innerText });
        })
      }
    })
  }
}
